module.exports = __webpack_public_path__ + "static/media/double-asterisk.5b4961e5.svg";